import { render, staticRenderFns } from "./UserConsumptionSummary.vue?vue&type=template&id=27b60fa4&scoped=true"
import script from "./UserConsumptionSummary.vue?vue&type=script&lang=js"
export * from "./UserConsumptionSummary.vue?vue&type=script&lang=js"
import style0 from "./UserConsumptionSummary.vue?vue&type=style&index=0&id=27b60fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b60fa4",
  null
  
)

export default component.exports